import React from 'react';
import { motion } from 'framer-motion';
import { Twitter } from 'lucide-react';

export const Header: React.FC = () => {
  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-4 md:px-6 3xl:px-8 4xl:px-12 5xl:px-16 py-4 md:py-6 3xl:py-8 4xl:py-10 5xl:py-12 backdrop-blur-sm bg-oled/50 border-b border-white/5"
    >
      {/* Left side - X.com button */}
      <div className="flex items-center">
        <button
          onClick={() => window.open('https://x.com/LowBatterySol', '_blank')}
          className="flex items-center gap-2 px-3 md:px-4 3xl:px-5 4xl:px-6 5xl:px-8 py-2 md:py-3 3xl:py-4 4xl:py-5 5xl:py-6 hover:bg-white/5 rounded-lg transition-all duration-300 group"
        >
          <Twitter className="w-4 h-4 md:w-5 md:h-5 3xl:w-6 3xl:h-6 4xl:w-7 4xl:h-7 5xl:w-8 5xl:h-8 text-white/60 group-hover:text-white transition-colors" />
          <span className="text-sm md:text-base 3xl:text-lg 4xl:text-xl 5xl:text-2xl text-white/60 group-hover:text-white transition-colors font-light">
            X.com
          </span>
        </button>
      </div>
      
      {/* Center - Title */}
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <h1 className="text-xl md:text-2xl 3xl:text-3xl 4xl:text-4xl 5xl:text-5xl font-light tracking-tight text-white/90 lowercase hover:text-white transition-colors cursor-default text-center">
          low battery pigeon <span className="text-neutral-600 text-sm md:text-sm 3xl:text-base 4xl:text-lg 5xl:text-xl align-top ml-1">$1pct</span>
        </h1>
      </div>
      
      {/* Right side - Empty for balance */}
      <div className="flex items-center">
        {/* Empty div to maintain balance */}
      </div>
    </motion.header>
  );
};